import SpreedlyFrame from "@eisinc/MobiusOverrides/SpreedlyFrame";

export default SpreedlyFrame;

export * from "@eisinc/MobiusOverrides/SpreedlyFrame";
